import Vue from 'vue'

import { globalErrorHandler, globalErrorProcessor, orderDirections, projectName, services, states } from '@/utils'

import render from './render'

const apiPath = `/n/${services['otp-handler']}`
const order = [ [ 'createdAt', orderDirections.DESC ] ]

export default {
  name: 'ThirdCol',

  data() {
    let limit = 10
    try {
      const parsedLimit = JSON.parse(window.localStorage.getItem(`${projectName}:pagination:limit:${services['otp-handler']}:request`))
      if (typeof parsedLimit === 'number') {
        limit = parsedLimit
      }
    } catch (error) {
    }

    return {
      tab: undefined,
      dialogTab: 'request',
      showDialog: false,

      state: states.empty,

      items: [],
      item: undefined,

      pagination: {
        limit,
        offset: 0,
        total: 0
      }
    }
  },

  computed: {
    widgetId() {
      return this.$route?.params?.id
    },

    hasItems() {
      return Array.isArray(this.items) && this.items.length > 0
    },
    hasPermissions() {
      return this.checkPermissions(`advanced.${services['otp-handler']}.get`)
    },

    tabs() {
      const result = []
      if (this.hasPermissions) {
        result.push('requests')
      }

      return result.map(key => {
        return {
          key,
          title: this.getTranslate(`commons.tabs.${key}`)
        }
      })
    },
    dialogTabs() {
      const result = [ 'request', 'channels' ]

      return result.map(key => {
        return {
          key,
          title: this.getTranslate(`commons.tabs.${key}`)
        }
      })
    }
  },

  watch: {
    'pagination.offset'() {
      this.getItems()
    }
  },

  mounted() {
    this.tab = this.tabs[0]?.key
    this.getItems()
  },

  methods: {
    queryProcessor(query) {
      return {
        ...query,
        offset: this.pagination.offset,
        limit: this.pagination.limit,
        order
      }
    },

    async getItems() {
      if (this.widgetId && this.hasPermissions) {
        try {
          this.state = states.loading
          const { data } = await Vue.$GRequest.get(apiPath, 'request', { query: this.queryProcessor({ widgetId: this.widgetId }) })
          if (data?.data) {
            this.state = states.success
            this.items = data.data
            this.pagination.total = data.total
          }
        } catch (error) {
          this.state = states.error
          globalErrorHandler.call(this, globalErrorProcessor.call(this, error))
        } finally {
          this.state = states.ready
        }
      }
    }
  },

  render
}
